import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
//
// Copyright IBM Corp. 2022
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
import React from 'react';
import PropTypes from 'prop-types';
import { OverflowMenu, OverflowMenuItem } from 'carbon-components-react';
import { ArrowsVertical32, ArrowUp16, ArrowDown16 } from '@carbon/icons-react';
import { pkg } from '../../settings';
var blockClass = "".concat(pkg.prefix, "--add-select-sort");
var componentName = 'AddSelectSort';
export var AddSelectSort = function AddSelectSort(_ref) {
  var setSortAttribute = _ref.setSortAttribute,
      setSortDirection = _ref.setSortDirection,
      sortBy = _ref.sortBy;
  var sortByOpts = sortBy ? sortBy.reduce(function (acc, cur) {
    var opts = [{
      id: "".concat(cur, "-asc"),
      itemText: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArrowUp16, null), cur),
      direction: 'asc',
      attribute: cur
    }, {
      id: "".concat(cur, "-desc"),
      itemText: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArrowDown16, null), cur),
      direction: 'desc',
      attribute: cur
    }];
    return [].concat(_toConsumableArray(acc), opts);
  }, []) : []; // handlers

  var sortHandler = function sortHandler(_ref2) {
    var direction = _ref2.direction,
        attribute = _ref2.attribute;
    setSortAttribute(attribute);
    setSortDirection(direction);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: blockClass
  }, sortByOpts.length > 0 && /*#__PURE__*/React.createElement(OverflowMenu, {
    className: "".concat(blockClass, "_overflow"),
    renderIcon: ArrowsVertical32,
    flipped: true
  }, sortByOpts.map(function (opt) {
    return /*#__PURE__*/React.createElement(OverflowMenuItem, {
      className: "".concat(blockClass, "_overflow-item"),
      key: opt.id,
      itemText: opt.itemText,
      onClick: function onClick() {
        return sortHandler(opt);
      }
    });
  })));
};
AddSelectSort.propTypes = {
  setSortAttribute: PropTypes.func,
  setSortDirection: PropTypes.func,
  sortBy: PropTypes.array
};
AddSelectSort.displayName = componentName;